/**
 * Copyright © 2018 Emu Analytics
 */

import { Client } from './client';
import { IStyle } from './api-interfaces';

export class MapEndpoints {
  constructor(private readonly client: Client) {}

  get(id: string, params: Record<string, any> = {}): Promise<IStyle> {
    return this.client._get(`/maps/${id}.json`, { params });
  }
}
